module.exports = __webpack_public_path__ + "static/media/roadMapViewzz.e445cfb3.svg";